/** @format */

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { FormikProps, FormikTouched } from 'formik';
import * as React from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectConstants } from './Api/constantSlice';
import { DropdownDto } from './Api/Models';
import { ErrorBox } from '../custom/ErrorBox';

interface Props {
  formik: FormikProps<any>;
  name: string;
  value: number;
  error: boolean | undefined;
  touched: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
}
export default function Provinces({
  formik,
  name,
  value,
  error,
  touched,
}: Props) {
  const selData = useAppSelector(selectConstants);
  return (
    <>
      {selData.constantState.provinces && (
        <>
          <FormControl fullWidth>
            <InputLabel error={error} id='demo-select-small'>
              Provinces
            </InputLabel>
            <Select
              name={name}
              labelId='demo-select-small'
              id='demo-select-small'
              value={value}
              label='Province'
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              error={error}>
              <MenuItem value={0} disabled>
                Select Province
              </MenuItem>
              {selData.constantState.provinces.map(
                (item: DropdownDto, key: number) => {
                  return (
                    <MenuItem key={key} value={item.id}>
                      {item.description}
                    </MenuItem>
                  );
                }
              )}
            </Select>
          </FormControl>

           <ErrorBox>
           {touched && (error as React.ReactNode)}
                    </ErrorBox>


         
        </>
      )}
    </>
  );
}
